import { Grid } from "@material-ui/core";
import React from "react";
import { Button, CloneButton, Confirm, Create, Datagrid, Edit, EditButton, Filter, Labeled, List, NumberField, NumberInput, required, SaveButton, SelectInput, Show, ShowButton, SimpleForm, SimpleShowLayout, TextField, TextInput, Toolbar, TopToolbar, useNotify, useRecordContext } from "react-admin";
import { Link } from "react-router-dom";
import { PopupboxContainer } from "react-popupbox";
import dataProvider from "../../dataProvider";
import { MyDateField } from "../../MyDateField";
import { MyDateTimeInput } from "../../MyDateTimeInput";

const StatusField = (props) => {
  const record = useRecordContext();

  var style = {};
  if (record.status == "live") {
    style = { color: "red" };
  }

  return <TextField {...props} source="status" style={style} />;
};

const StartNowButton = () => {
  const [showConfirm, setShowConfirm] = React.useState(false);
  const record = useRecordContext();
  const notify = useNotify();

  return (
    <React.Fragment>
      <Button
        label="Start Now"
        disabled={["live", "end"].includes(record.status)}
        onClick={() => {
          setShowConfirm(true);
        }}
      />
      <Confirm
        isOpen={showConfirm}
        title="Are you sure you want to start this Link To Vertical Mode now?"
        onConfirm={async () => {
          try {
            await dataProvider.updateChannelLinkToVerticalMode(null, {
              id: record.id,
              data: {
                name: record.name,
                horizontal_channel_no: record.horizontal_channel_no,
                vertical_channel_no: record.vertical_channel_no,
                start_time: new Date().toISOString(),
                end_time: record.end_time,
              },
            });

            window.location.reload(true);
          } catch (error) {
            notify(error.message.toString(), "warning");
          }

          setShowConfirm(false);
        }}
        onClose={() => {
          setShowConfirm(false);
        }}
      />
    </React.Fragment>
  );
};

const EndNowButton = () => {
  const [showConfirm, setShowConfirm] = React.useState(false);
  const record = useRecordContext();
  const notify = useNotify();

  return (
    <React.Fragment>
      <Button
        label="End Now"
        disabled={record.status != "live"}
        onClick={() => {
          setShowConfirm(true);
        }}
      />
      <Confirm
        isOpen={showConfirm}
        title="Are you sure you want to end this Link To Vertical Mode now?"
        onConfirm={async () => {
          try {
            await dataProvider.updateChannelLinkToVerticalMode(null, {
              id: record.id,
              data: {
                name: record.name,
                horizontal_channel_no: record.horizontal_channel_no,
                vertical_channel_no: record.vertical_channel_no,
                start_time: record.start_time,
                end_time: new Date().toISOString(),
              },
            });
            window.location.reload(true);
          } catch (error) {
            notify(error.message.toString(), "warning");
          }

          setShowConfirm(false);
        }}
        onClose={() => {
          setShowConfirm(false);
        }}
      />
    </React.Fragment>
  );
};

const CustomFilter = (props) => (
  <Filter {...props}>
    <TextInput label="Vertical Mode ID" source="id" alwaysOn />
    <TextInput label="Name" source="name" alwaysOn />
    <TextInput label="Horizontal Channel No." source="horizontal_channel_no" alwaysOn />
    <TextInput label="Vertical Channel No." source="vertical_channel_no" alwaysOn />
    <SelectInput
      label="Status"
      source="status"
      choices={[
        { id: "live", name: "Live" },
        { id: "preview", name: "Preview" },
        { id: "end", name: "End" },
      ]}
      alwaysOn
    />
  </Filter>
);

const ListActions = () => (
  <TopToolbar>
    <Button
      color="primary"
      component={Link}
      to={{
        pathname: `/channel-link-to-vertical-mode/create`,
      }}
      label="+ CREATE"
    />
  </TopToolbar>
);

const CustomEditButton = (props) => {
  return <EditButton disabled={["end"].includes(props.record.status)} {...props} />;
};

export const ChannelLinkToVerticalModeList = (props) => (
  <List {...props} sort={{ field: "created_at", order: "DESC" }} bulkActionButtons={false} filters={<CustomFilter />} actions={<ListActions />}>
    <Datagrid>
      <TextField source="id" label="Vertical Mode ID" />
      <TextField source="name" label="Name" />
      <TextField source="horizontal_channel_no" label="Horizontal Channel No." />
      <TextField source="vertical_channel_no" label="Vertical Channel No." />
      <StatusField label="Status" />
      <MyDateField source="start_time" showTime />
      <MyDateField source="end_time" showTime />
      <StartNowButton />
      <EndNowButton />
      <ShowButton />
      <CustomEditButton />
      <CloneButton />
    </Datagrid>
  </List>
);

const redirectChannelLinkToVerticalMode = () => "/channel-link-to-vertical-mode";

export const ChannelLinkToVerticalModeCreate = (props) => {
  const notify = useNotify();
  const onFailure = (error) => {
    notify(error.message.toString(), "warning");
  };

  return (
    <>
      <Create {...props} onFailure={onFailure}>
        <SimpleForm toolbar={<Toolbar alwaysEnableSaveButton={true} />} redirect={redirectChannelLinkToVerticalMode}>
          <>
            <Grid container spacing={1} fullWidth>
              <Grid item xs={12} sm={12} md={6}>
                <TextInput source="name" validate={required()} fullWidth />
              </Grid>
              <Grid item xs={12} sm={12} md={6}>
                <NumberInput label="Horizontal Channel Number" source="horizontal_channel_no" validate={required()} fullWidth />
              </Grid>
              <Grid item xs={12} sm={12} md={6}>
                <NumberInput label="Vertical Channel Number" source="vertical_channel_no" validate={required()} fullWidth />
              </Grid>
            </Grid>

            <Grid container spacing={1} fullWidth>
              <Grid item xs={12} sm={12} md={6}>
                <MyDateTimeInput label="Start Time" source="start_time" fullWidth validate={required()} />
              </Grid>
              <Grid item xs={12} sm={12} md={6}>
                <MyDateTimeInput label="End Time" source="end_time" fullWidth validate={required()} />
              </Grid>
            </Grid>
          </>
        </SimpleForm>
      </Create>
      <PopupboxContainer />
    </>
  );
};

const ChannelLinkToVerticalModeTitle = ({ record }) => {
  return <span>{record.name}</span>;
};

const ChannelLinKToVerticalModeEditForm = ({ record }) => {
  return (
    <>
      <Grid container spacing={1} fullWidth>
        <Grid item xs={12} sm={12} md={6}>
          <TextInput source="name" validate={required()} fullWidth disabled={["live", "end"].includes(record.status)} />
        </Grid>
        <Grid item xs={12} sm={12} md={6}>
          <NumberInput label="Horizontal Channel Number" source="horizontal_channel_no" validate={required()} fullWidth disabled={["live", "end"].includes(record.status)} />
        </Grid>
        <Grid item xs={12} sm={12} md={6}>
          <NumberInput label="Vertical Channel Number" source="vertical_channel_no" validate={required()} fullWidth disabled={["live", "end"].includes(record.status)} />
        </Grid>
      </Grid>

      <Grid container spacing={1} fullWidth>
        <Grid item xs={12} sm={12} md={6}>
          <MyDateTimeInput label="Start Time" source="start_time" fullWidth validate={required()} disabled={["live", "end"].includes(record.status)} />
        </Grid>
        <Grid item xs={12} sm={12} md={6}>
          <MyDateTimeInput label="End Time" source="end_time" fullWidth validate={required()} disabled={["end"].includes(record.status)} />
        </Grid>
      </Grid>
    </>
  );
};

export const ChannelLinkToVerticalModeEdit = (props) => {
  const notify = useNotify();
  const onFailure = (error) => {
    notify(error.message.toString(), "warning");
  };

  const CustomToolbar = (props) => (
    <Toolbar {...props}>
      <SaveButton label="SAVE" />
    </Toolbar>
  );

  return (
    <>
      <Edit {...props} onFailure={onFailure} mutationMode="pessimistic" title={<ChannelLinkToVerticalModeTitle />}>
        <SimpleForm redirect={redirectChannelLinkToVerticalMode} toolbar={<CustomToolbar />}>
          <ChannelLinKToVerticalModeEditForm {...props} />
        </SimpleForm>
      </Edit>
      <PopupboxContainer />
    </>
  );
};
const CustomShowActions = () => {
  const record = useRecordContext(); // Access the current record

  if (!record || record.status === "end") {
    // Do not show the Edit button if the status is "end"
    return null;
  }

  return (
    <TopToolbar>
      <EditButton basePath="/channel-link-to-vertical-mode" record={{ id: record.id }} />
    </TopToolbar>
  );
};

export const ChannelLinkToVerticalModeShow = (props) => {
  return (
    <Show {...props} title={<ChannelLinkToVerticalModeTitle />} actions={<CustomShowActions {...props} />}>
      <SimpleShowLayout>
        <Grid container spacing={1} fullWidth>
          <Grid item xs={12} sm={12} md={6}>
            <Labeled label="Name">
              <TextField source="name" />
            </Labeled>
          </Grid>
          <Grid item xs={12} sm={12} md={6}>
            <Labeled label="Horizontal Channel Number.">
              <NumberField source="horizontal_channel_no" />
            </Labeled>
          </Grid>
          <Grid item xs={12} sm={12} md={6}>
            <Labeled label="Vertical Channel Number.">
              <NumberField source="vertical_channel_no" />
            </Labeled>
          </Grid>
        </Grid>

        <Grid container spacing={1} fullWidth>
          <Grid item xs={12} sm={12} md={6}>
            <Labeled label="Start Time">
              <MyDateField showTime source="start_time" />
            </Labeled>
          </Grid>
          <Grid item xs={12} sm={12} md={6}>
            <Labeled label="End Time">
              <MyDateField showTime source="end_time" />
            </Labeled>
          </Grid>
        </Grid>
      </SimpleShowLayout>
    </Show>
  );
};
